import { render, staticRenderFns } from "./MessageDetails.vue?vue&type=template&id=7c0da166&scoped=true"
import script from "./MessageDetails.vue?vue&type=script&lang=js"
export * from "./MessageDetails.vue?vue&type=script&lang=js"
import style0 from "./MessageDetails.vue?vue&type=style&index=0&id=7c0da166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0da166",
  null
  
)

export default component.exports